import { buildProps } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'

import type StatisticCountdown from './statistic-countdown.vue'
import type Statistic from './statistic.vue'

export const statisticProps = buildProps({
  // 是否显示千分位间隔符
  showKilobit: {
    type: Boolean,
    default: true,
  },

  // 千分位间隔符
  groupSeparator: {
    type: String,
    default: ',',
  },
})

export type StatisticProps = ExtractPropTypes<typeof statisticProps>

// instance
export type StatisticInstance = InstanceType<typeof Statistic>
export type StatisticCountdownInstance = InstanceType<typeof StatisticCountdown>
